import type { IncomingMessage, ServerResponse } from 'node:http';
import type { BridgeMcpToolRegistry } from '../bridge-mcp-tool-types.js';
import { readJsonBody } from './read-json-body.js';
import { sendJsonResponse } from './send-json-response.js';

export function createBridgeAccessRequestHandler(registry: BridgeMcpToolRegistry): (
  req: IncomingMessage,
  res: ServerResponse,
) => void {
  return (req, res) => {
    void (async () => {
      if (req.method !== 'POST') {
        sendJsonResponse(res, 405, { ok: false, error: 'Method not allowed' });
        return;
      }

      try {
        const body = await readJsonBody(req);

        if (req.url === '/tools/list') {
          const tools = await Promise.resolve(registry.listTools());
          sendJsonResponse(res, 200, { ok: true, data: tools });
          return;
        }

        if (req.url === '/tools/call') {
          const sessionId = typeof body.sessionId === 'string' ? body.sessionId.trim() : '';
          if (!sessionId) {
            sendJsonResponse(res, 400, { ok: false, error: 'sessionId is required' });
            return;
          }
          const name = typeof body.name === 'string' ? body.name.trim() : '';
          const args =
            body.args && typeof body.args === 'object' && !Array.isArray(body.args)
              ? (body.args as Record<string, unknown>)
              : {};
        if (!name) {
          sendJsonResponse(res, 400, { ok: false, error: 'name is required' });
          return;
        }
        const data = await registry.callTool(name, { ...args, sessionId });
          sendJsonResponse(res, 200, { ok: true, data });
          return;
        }

        sendJsonResponse(res, 404, { ok: false, error: 'Not found' });
      } catch (err) {
        const message = err instanceof Error ? err.message : String(err);
        sendJsonResponse(res, 500, { ok: false, error: message });
      }
    })();
  };
}
